import * as React from 'react';
import * as _ from 'underscore';

import { ProgressBar } from '../../../_common/platform/tsx/ProgressBar';

import { IDirContentItem } from '../ts/stores/WorkspacesDirsStore';

const moment = require('pdc-platform-moment');

const ISO_DATE_TIME_REGEX = /^\d\d\d\d-\d\d-\d\dT\d\d:\d\d:\d\d(\.\d+)?Z$/;

const NAVIGATOR_LANG =
    (navigator as any).browserLanguage != null ? (navigator as any).browserLanguage : navigator.language;

export function DirsWorkspacesSingle(props: {
    select;
    content: IDirContentItem[];
    multipleSelectMode: boolean;
    allowSelect: boolean;
    loading: boolean;

    onSelect(select, name: string): void;
}) {
    const transformSelect = (select) => {
        let newSelect;

        if (select != null) {
            newSelect = select;
        } else if (props.multipleSelectMode) {
            newSelect = {};
        } else {
            newSelect = null;
        }

        if (props.multipleSelectMode && typeof newSelect !== 'object') {
            newSelect = {};
        }

        return newSelect;
    };

    const processSelectValue = (select, name) => {
        if (typeof props.onSelect === 'function') {
            props.onSelect(select, name);
        }
    };

    const getSingleClickHandler = (id, name) => {
        return (e) => {
            processSelectValue(id, name);
        };
    };

    const getMultipleClickHandler = (id, name) => {
        return (e) => {
            const select = transformSelect(props.select);
            const checked = select[id] != null;

            if (checked) {
                delete select[id];
            } else {
                select[id] = name;
            }

            processSelectValue(select, null);
        };
    };

    const getClickHandler = (id, name) => {
        //VR: do not allow to select a WS row!
        if (props.allowSelect !== true) {
            return null;
        }

        if (props.multipleSelectMode) {
            return getMultipleClickHandler(id, name);
        } else {
            return getSingleClickHandler(id, name);
        }
    };

    const getView = () => {
        let classDisallowPointer = '';

        //VR: do not allow to select a WS row!
        if (props.allowSelect !== true) {
            classDisallowPointer = ' tr-disallow-pointer';
        }

        if (props.content == null) {
            if (props.loading) {
                return <ProgressBar />;
            } else {
                return (
                    <em className="empty-non-select">
                        <span className="arrow">←</span>
                        <span>{'Select folder on the left'}</span>
                    </em>
                );
            }
        }

        if (props.content.length === 0) {
            return <em>{'Folder is empty'}</em>;
        }

        const select = transformSelect(props.select);

        let selectMap;

        if (typeof select === 'object' && select != null) {
            selectMap = select;
        } else {
            selectMap = {};
            selectMap[select] = true;
        }

        const content = _.map(props.content, (item, i) => {
            const dateCreated = item.dateCreated;

            let dateCreatedText: string;

            if (dateCreated != null) {
                dateCreatedText = dateCreated.toString();

                if (ISO_DATE_TIME_REGEX.test(dateCreatedText)) {
                    //Is ISODateCreated
                    dateCreatedText = moment(dateCreated, moment.ISO_8601).locale(NAVIGATOR_LANG).format('llll');
                }
            }
            // else {
            //     dateCreatedText = '';
            // }

            return (
                <tr
                    key={i}
                    onClick={getClickHandler(item.wsid, item.name)}
                    data-id={item.wsid}
                    className={'workspace-row' + (selectMap[item.wsid] ? ' selected' : '') + classDisallowPointer}
                >
                    <td className="multiple-select-column">
                        <input checked={selectMap[item.wsid] != null} type="checkbox" readOnly={true} />
                    </td>

                    <td>{item.name}</td>

                    <td>{dateCreatedText}</td>

                    <td>{item.owner}</td>
                </tr>
            );
        });

        return (
            <table className="table">
                <thead>
                    <tr>
                        <th className="multiple-select-column"></th>
                        <th>{'Name'}</th>
                        <th>{'Date created'}</th>
                        <th>{'Owner'}</th>
                    </tr>
                </thead>

                <tbody>{content}</tbody>
            </table>
        );
    };

    let content: React.JSX.Element;

    if (props.loading) {
        content = <ProgressBar />;
    } else {
        content = getView();
    }

    return <div className={'dir-single' + (props.multipleSelectMode ? ' multiple-select' : '')}>{content}</div>;
}
